/**
 * P1 / P2 / P3 of a review or email draft — one look everywhere: a small
 * mono outlined badge, P1 danger, P2 warn, P3 muted (`reviewPriorityTone`).
 * `long` adds the email inbox's words ("P1 Urgent").
 */
import { clsx } from "clsx";

import { reviewPriorityTone } from "../lib/aiTeam";
import { PRIORITY_LABELS } from "../lib/emailDrafts";

const TONE_CLASS = {
  alert: "prio-badge prio-badge--alert",
  signal: "prio-badge prio-badge--signal",
  muted: "prio-badge prio-badge--muted",
  ok: "prio-badge prio-badge--muted",
} as const;

export function PriorityBadge({ priority, long = false }: { priority?: number | null; long?: boolean }) {
  if (priority == null) {
    return <span className={clsx(TONE_CLASS.muted)} title="No priority">{long ? "Unprioritized" : "P–"}</span>;
  }
  const label = long ? (PRIORITY_LABELS[priority] ?? `P${priority}`) : `P${priority}`;
  return (
    <span className={TONE_CLASS[reviewPriorityTone(priority)]} title={PRIORITY_LABELS[priority]}>
      {label}
    </span>
  );
}
